export default {
    login_username: 'Usuario',
    login_password: 'Contraseña',
    login_required_filed: 'Campo requerido',
    login_forgot_password: '¿Ha olvidado su contraseña?',
    login_sign_in: 'Iniciar Sesión',
    login_sign_in_with_google: 'Acceder con Google',
    login_sign_in_with_username: 'Acceder con el nombre de usuario',
    page_not_found: 'Oops! Golpeamos un tope de velocidad',
    page_not_found_message: 'Parece que no se encuentra la página que está buscando. Si necesita que lo lleven a otro lugar, pruebe con uno de los botones de la izquierda',
};